import * as React from 'react';

import { usePaymentStatusContainer } from './hooks';
import { PaymentStatus } from './PaymentStatus';

export const PaymentStatusContainer = () => {
  const { status, handleRetryClick } = usePaymentStatusContainer();

  if (!status) {
    return null;
  }

  return <PaymentStatus status={status} handleRetryClick={handleRetryClick} />;
};
